import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { useWindowSize } from '@yme/common/hooks';
import { Overview } from '@yme/components/Destinations/PartnerDetailsPage/components/Overview';
import { CardWrapperStyled, DescriptionStyled, } from '@yme/components/Destinations/PartnerDetailsPage/components/PartnerDetailsCard/styled';
import { getPartnerDetailsPageState } from '@yme/components/Destinations/PartnerDetailsPage/redux/selectors';
import { IndentWrapper } from '@yme/components/Separator';
import { getBloomreachModel, getGlobalSearchItemId, getIsInAuthor } from '@yme/selectors/common';
import { setPixelPageView, PixelPageView } from '@yme/utils/bloomreach';
import { AspectRatio } from '@yme/utils/constants';
export function PartnerDetailsCard({ isRemoveBottomIndent }) {
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const { partnerName, partnerLogo, partnerIntro } = useSelector(getPartnerDetailsPageState);
    const globalSearchItemId = useSelector(getGlobalSearchItemId);
    const { productCatalog, contentCatalog } = useSelector(getBloomreachModel);
    const isInAuthor = useSelector(getIsInAuthor);
    useEffect(() => {
        if (productCatalog && contentCatalog && globalSearchItemId && !isInAuthor) {
            setPixelPageView(PixelPageView.CONTENT, {
                catalogs: [
                    {
                        name: contentCatalog,
                    },
                ],
                item_id: globalSearchItemId,
                item_name: document.title,
                domain_key: productCatalog,
            });
        }
    }, [contentCatalog, globalSearchItemId, isInAuthor, productCatalog]);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(CardWrapperStyled, null,
            React.createElement(Container, { maxWidth: isInfiniteDesktopView ? '756px' : '100%', pt: "48px" },
                React.createElement(Row, null,
                    React.createElement(Col, { lg: 7, md: 4 },
                        React.createElement(Image, { ...partnerLogo, alt: partnerName, aspectRatio: AspectRatio.RectangleLevel3 })),
                    !isMobileView && (React.createElement(Col, { lg: 5, md: 4 },
                        React.createElement(Overview, null)))),
                partnerIntro?.html && (React.createElement(Row, { mt: "24px" },
                    React.createElement(Col, null,
                        React.createElement(DescriptionStyled, { dangerouslySetInnerHTML: {
                                __html: sanitizeHtml(partnerIntro.html),
                            } })))),
                isMobileView && (React.createElement(Row, { mt: "24px" },
                    React.createElement(Col, null,
                        React.createElement(Overview, null))))))));
}
PartnerDetailsCard.displayName = 'PartnerDetailsCard_AEMComponent';
